<template>
    <CommonBox title="Edit Partner" @close="$emit('close')" @submit="submit">
        <el-form ref="form" label-width="360px" :model="initForm" :rules="rules">
            <el-form-item label="ACIA(Akuvox Certified Intercom Associate)" prop="ACIA">
                <el-input v-model="initForm.ACIA"></el-input>
            </el-form-item>

            <el-form-item  label="ACIP(Akuvox Certified Intercom Profession)" prop="ACIP">
                <el-input v-model="initForm.ACIP"></el-input>
            </el-form-item>

            <el-form-item label="ACIE(Akuvox Certified Intercom Expert)" prop="ACIE">
                <el-input v-model="initForm.ACIE"></el-input>
            </el-form-item>

        </el-form>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
export default {
    components:{
        CommonBox
    },
    props:{
        initForm:{}
    },
    data () {
        return {
            rules:{
                ACIA:[{required: true, message: 'ACIA Engineer’s name. e.g. “Mark, John, Jason”', trigger: 'blur'}],
                ACIE:[{required: true, message: 'ACIE Engineer’s name. e.g. “Mark, John, Jason”', trigger: 'blur'}],
                ACIP:[{required: true, message: 'ACIP Engineer’s name. e.g. “Mark, John, Jason”', trigger: 'blur'}]
            }
        };
    },
    mounted () {
    },
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let from = Object.assign({},this.initForm);
                let methods = 'put';
                let url = 'setPartnerEngineer';
                this.$http[methods](url,from,(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$emit('close');
                    this.$emit('update');
                });
            });
        }
    }
};
</script>
